import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffCrudInformation = () => import('./staff/crudInformation')
const ViewStaffReports = () => import('./staff/reports')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SocialNetworksStaffDashboard',
  configuration: 'SocialNetworksStaffConfiguration',
  crudInformation: 'SocialNetworksStaffCrudInformation',
}

const router =
  [
    {
      path: '/st/social-networks',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Redes sociales',
          }                            
        },
        {
          path: 'configuration',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuracion de redes sociales',
          }                            
        }, 
        {
          path: 'crud-information',
          name: VIEWS.crudInformation,
          component: ViewStaffCrudInformation,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Información de redes sociales',
          }                            
        },    
        {
          path: 'reports',
          name: 'SocialNetworksStaffReports',
          component: ViewStaffReports,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reportes de redes sociales',
          }                            
        },                    
      ]
    },

    {
      path: '/cu/social-networks',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/social-networks',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
